<div class="fs-2 success with-close" mat-dialog-title>
    Félicitations !
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <b>Félicitations pour votre achat ! 🎉</b>
    <br/>
    <p class="text-center mt-4 mb-4">
        <img src="assets/party%20popper.png">
    </p>
    <p>
        Votre bien est passé au statut « Propriétaire » : il fait maintenant partie de votre parc et est
        accessible dans votre page <b>Mon patrimoine</b>.
    </p>
    <p class="mb-0">Vous y retrouverez vos loyers, cash-flows, la santé de vos villes et bien plus 🏢</p>
</div>
<div mat-dialog-actions>
    <button type="button" (click)="onNoClick()" class="btn btn-outline">Fermer</button>
    <a class="btn btn-primary" routerLink="/app/patrimoine" (click)="onNoClick()">
        <i class="fa fa-eye"></i> Voir mon patrimoine
    </a>
</div>
